export function getSortOrderOptions() {
    const defaultOptions = [
        {
            id: 'newest_listings',
            text: 'Most recent'
        },
        {
            id: 'highest_price',
            text: 'Highest price'
        },
        {
            id: 'lowest_price',
            text: 'Lowest price'
        },
        {
            id: 'most_reduced',
            text: 'Most reduced'
        }
    ];

    return {
        'for-sale': {
            default: {
                id: 'newest_listings',
                text: 'Most recent'
            },
            options: defaultOptions
        },

        'to-rent': {
            default: {
                id: 'newest_listings',
                text: 'Most recent'
            },
            options: defaultOptions
        },
        'new-homes': {
            default: { id: 'recommended', text: 'Recommended' },
            options: [
                { id: 'recommended', text: 'Recommended' },
                ...defaultOptions
            ]
        }
    };
}
